import { useTranslation } from "react-i18next";
import { IconCheck } from "@tabler/icons-react";
import { Menu, UnstyledButton } from "@mantine/core";

import { UI_LOCALES, UI_LOCALE_LABEL_KEYS } from "@constants/languages";

function languageLabel(lng: string) {
  const [language, region] = (lng || "").split("-");
  return region ? `${language.toUpperCase()}-${region.toUpperCase()}` : language.toUpperCase();
}

export default function LanguageChanger() {
  const { t, i18n } = useTranslation();
  const language = languageLabel(i18n.language);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-dropdown">
      <Menu
        position="bottom-end"
        withinPortal={false}
        classNames={{ dropdown: "language-menu-dropdown", item: "language-menu-item" }}
      >
        <Menu.Target>
          {/* Menu.Target overwrites `id` with its own aria target, so style by class. */}
          <UnstyledButton className="language-dropdown-toggle">{language}</UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          {UI_LOCALES.map((locale) => {
            const isSelected = locale === i18n.language;
            return (
              <Menu.Item
                key={locale}
                onClick={() => changeLanguage(locale)}
                aria-current={isSelected ? "true" : undefined}
                fw={isSelected ? 700 : undefined}
                rightSection={isSelected ? <IconCheck size={14} /> : undefined}
              >
                {t(UI_LOCALE_LABEL_KEYS[locale])}
              </Menu.Item>
            );
          })}
        </Menu.Dropdown>
      </Menu>
    </div>
  );
}
